import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useGetMCTMonitoring from 'hooks/Reports/MCTMonitoring/MCTMonitoring';

interface InnerMctMonitoringProps {
  slug: string;
  startDate: string;
  endDate: string;
}

const InnerMctMonitoring: React.FC<InnerMctMonitoringProps> = ({ slug, startDate, endDate }) => {
  const { data } = useGetMCTMonitoring(slug, startDate, endDate);
  const { t } = useTranslation();

  const allSignalDatesNull =
    data &&
    data.length > 0 &&
    data.every(trap => trap.signals.length === 0 || trap.signals.every(signal => signal.date == null));

  return (
    <div className="row mb-5">
      <h5 className="text-center">{t('VisitReportsPDF.header.MCTMonitoring')}</h5>
      {allSignalDatesNull && (
        <div className="text-center text-success mb-2">
          {t('VisitReportsPDF.header.noMiceDuringPeriod', { startDate: startDate, endDate: endDate })}
        </div>
      )}
      <table className="w-100">
        <thead className="">
          <tr className="ml-th-bordered-bottom-dark">
            <th className="text-center mct-th" scope="col">
              {t('VisitReportsPDF.monitoring-table.trap-number')}
            </th>
            <th className="text-center mct-th" scope="col">
              {t('VisitReportsPDF.monitoring-table.trap-serial-number')}
            </th>
            <th className="text-center mct-th install-date" scope="col">
              {t('VisitReportsPDF.monitoring-table.install-date')}
            </th>
            <th className="text-center mct-th" scope="col">
              {t('VisitReportsPDF.monitoring-table.signal-dates')}
            </th>
            <th className="text-center mct-th" scope="col">
              {t('VisitReportsPDF.monitoring-table.signal-time')}
            </th>
            <th className="text-center mct-th" scope="col">
              Mice count
            </th>
          </tr>
        </thead>
        <tbody className="mct-tbody">
          {data && data.length > 0 ? (
            data.map(trapMonitroingData => {
              const totalRowSpan =
                trapMonitroingData.signals.length > 0
                  ? trapMonitroingData.signals.reduce((acc, cur) => acc + cur.time.length, 0)
                  : 1;

              return trapMonitroingData.signals.length > 0 ? (
                trapMonitroingData.signals.map((signal, index) =>
                  signal.time.map((time, timeIndex) => (
                    <tr
                      className=""
                      key={`${trapMonitroingData.sequence_number}-${trapMonitroingData.date_of_installation}-${index}-${timeIndex}`}
                    >
                      {index === 0 && timeIndex === 0 && (
                        <>
                          <td className="text-center align-top mct-td" rowSpan={totalRowSpan}>
                            <div className="sticky-cell">{trapMonitroingData.sequence_number || 'N/A'}</div>
                          </td>
                          <td className="text-center align-top mct-td" rowSpan={totalRowSpan}>
                            <div className="sticky-cell">{trapMonitroingData.serial_number}</div>
                          </td>
                          <td className="text-center align-top mct-td" rowSpan={totalRowSpan}>
                            <div className="sticky-cell">{trapMonitroingData.date_of_installation || 'N/A'}</div>
                          </td>
                        </>
                      )}
                      {timeIndex === 0 && (
                        <>
                          <td className="text-center align-top mct-td" rowSpan={signal.time.length}>
                            <div className="sticky-cell">{dayjs(signal.date).format('YYYY-DD-MM')}</div>
                          </td>
                          <td className="text-center align-top mct-td" rowSpan={signal.time.length}>
                            <div className="sticky-cell">{signal.time.length}</div>
                          </td>
                        </>
                      )}
                      <td className="text-center mct-td signal-time">{time.inner_time}</td>
                    </tr>
                  )),
                )
              ) : (
                <tr
                  className="align-content-center"
                  key={`${trapMonitroingData.sequence_number}-${trapMonitroingData.date_of_installation}-empty`}
                >
                  <td className="text-center mct-td" rowSpan={totalRowSpan}>
                    {trapMonitroingData.sequence_number || 'N/A'}
                  </td>
                  <td className="text-center mct-td" rowSpan={totalRowSpan}>
                    {trapMonitroingData.serial_number}
                  </td>
                  <td className="text-center mct-td install-date" rowSpan={totalRowSpan}>
                    {trapMonitroingData.date_of_installation || 'N/A'}
                  </td>
                  <td className="text-center mct-td">---</td>
                  <td className="text-center mct-td">---</td>
                  <td className="text-center mct-td">---</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7} className="text-center mct-td text-success">
                {t('VisitReportsPDF.header.noMiceDuringPeriod', { startDate: startDate, endDate: endDate })}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InnerMctMonitoring;
